import { gql } from '@apollo/client';

export const GET_DASHBOARD_ANALYTICS = gql`
  query MyQuery(
    $dateRage: DateRangeInput!
    $period: Period!
    $sortBy: SortBy!
  ) {
    ProductAnalytics(dateRange: $dateRage, period: $period, sortBy: $sortBy) {
      data {
        orderStatusDistribution {
          count
          status
          totalPrice
        }
        revenueTrends {
          averageOrderValue
          orderCount
          period
          totalRevenue
        }
        topSellingProducts {
          productName
          productid
          totalQuantity
          totalRevenue
        }
        totalRevenue {
          totalQuantity
          totalRevenue
        }
      }
      error
      status
    }
  }
`;
